import { createApi } from './api';
export function create(config) {
  let axiosConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const api = createApi(config, axiosConfig);
  return {
    getAreas: () => api.getAreas(config.country).then(res => res.data)
  };
}